export const CAMPO_REQUERIDO = "Este campo es requerido.";
export const DATE_NO_VALIDA = "Esta fecha no es valida.";
export const CORREO_NO_VALIDO = "Correo no válido";
export const NUMERO_NO_VALIDO = "El número proporcionado no es válido";
